'use client';

import Spinner from '@/components/Spin/Spinner';

export default function CarDetailsLoading() {
    return <Spinner />;
}
